<template>
    <div class="shop-list-menu">
        <div class="hot-shop-titile">热卖商品</div>
        <div class="hot-shop-list">
        <div class="hot-shop-item" v-for="(item, index) in list" :key="index" @click="onDetail(item.id)">
            <div class="hot-shop-item-img">
            <img :src="item.image">
            </div>
            <div class="hot-shop-item-title">{{item.title}}</div>
            <div class="hot-shop-item-price">￥ {{item.price}}</div>
            <div class="host-shop-item-num">
            已售{{item.sold}}+
            </div>
        </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'ProductHotComponent',
  props: {
    list:{
      types: Array,
      required: false
    }
  },
  methods: {
    onDetail (id) {
        this.$router.push({name: 'detail', query:{ id: id}});
    },
  }
}
</script>
<style>
</style>
